import { batch } from 'react-redux';

import api from 'utils/axios';
import { decamelizeKeys } from 'utils/humps';

import { accountIdSelector } from '../../user/selectors';
import { selectedSelector } from './selectors';

import { addDataAction, clearSelectAction, setLoading } from './index';

export const loadDataThunk = () => async (dispatch, getState) => {
  dispatch(setLoading(true));
  const accountId = accountIdSelector(getState());
  const { orderBy, order, q, limit, page } = getState().router.location.query;

  const { data } = await api.get(`/acc/${accountId}/pages/pending`, {
    params: decamelizeKeys({ orderBy, order, q, limit, page }),
  });

  batch(() => {
    dispatch(setLoading(false));

    dispatch(
      addDataAction({
        data: data.data,
        pagination: data.meta,
      }),
    );
  });
};

export const publishThunk = (id) => async (dispatch, getState) => {
  const accountId = accountIdSelector(getState());

  await api.put(`/acc/${accountId}/pages/${id}/pending`);
  await dispatch(loadDataThunk());
};

export const approveThunk = (id, reason) => async (dispatch, getState) => {
  const accountId = accountIdSelector(getState());

  await api.put(`/acc/${accountId}/pages/${id}/approve`, { reason });
  await dispatch(loadDataThunk());
};

export const rejectThunk = (id, reason) => async (dispatch, getState) => {
  const accountId = accountIdSelector(getState());

  await api.put(`/acc/${accountId}/pages/${id}/reject`, { reason });
  await dispatch(loadDataThunk());
};

export const approveBulkThunk = (reason) => async (dispatch, getState) => {
  const accountId = accountIdSelector(getState());
  const ids = selectedSelector(getState());

  await api.put(`/acc/${accountId}/pages/approve`, { ids, reason });

  dispatch(clearSelectAction());
  dispatch(loadDataThunk(true));
};
